import React from 'react';
import { styled } from '@linaria/react';
import { Divider } from '@daedalus/atlas/Divider';
import { RoomContext } from '@daedalus/core/src/analytics/types/Events';
import { Room } from '@daedalus/core/src/room/types/room';
import { RoomDetailsMountComponent } from '../RoomCard/constants';
import { RoomOffer } from '../RoomOffer/RoomOffer';
const _exp = /*#__PURE__*/() => Divider;
const OfferDivider = /*#__PURE__*/styled(_exp())({
  name: "OfferDivider",
  class: "o11q5j25",
  propsAsIs: true
});
type PropsTypes = {
  hotelId: string;
  room: Room;
  component: RoomDetailsMountComponent;
  roomContext: RoomContext;
  visibleOffersAmount?: number;
};
export const RoomOffersList = ({
  hotelId,
  room,
  component,
  roomContext,
  visibleOffersAmount
}: PropsTypes) => {
  const visibleOffers = room.offers?.slice(0, visibleOffersAmount);
  return <>
      {visibleOffers.map((offer, index) => <React.Fragment key={offer.id}>
          <RoomOffer hotelId={hotelId} room={room} offer={offer} roomContext={roomContext} component={component} offerIndex={index} />
          {index < visibleOffers.length - 1 && <OfferDivider />}
        </React.Fragment>)}
    </>;
};

require("./RoomOffersList.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomOffersList.tsx");